import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthFormCard } from '@/components/AuthFormCard';
import { AuthFormInput } from '@/components/AuthFormInput';
import { authService } from '@/services/auth-service';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [completed, setCompleted] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await authService.requestPasswordReset(email);
      setCompleted(true);
    } catch {
      setError('The request could not be processed. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFormCard title="Forgot password">
      {completed ? (
        <>
          <p>If an account with this email address exists, a reset link has been sent. The link is valid for 30 minutes.</p>
          <Link className="auth-form-text-link" to="/">Back to login</Link>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="auth-form compact">
          <p>Enter your email address. You will receive a link to reset your password.</p>
          <AuthFormInput id="email" name="email" type="email" value={email} onChange={event => { setEmail(event.target.value); setError(null); }} disabled={loading} placeholder="Email address" required autoComplete="email" />
          {error && <div className="auth-form-error">{error}</div>}
          <button type="submit" className="auth-form-button" disabled={loading}>
            {loading ? 'Sending...' : 'Request link'}
          </button>
          <Link className="auth-form-secondary-link" to="/">Back to login</Link>
        </form>
      )}
    </AuthFormCard>
  );
};

export default ForgotPassword;
